import type { MinimalTarget } from '@/generated/model';
import { dateYMD } from '@/utilities/dateUtils';

import type { RefuelsDateRange } from '../types/RefuelsDateRange.types';

export const DEFAULT_EXPORT_FILE_NAME = 'iTrack';

export function getExportFileName(target: MinimalTarget | undefined, dates: RefuelsDateRange | undefined) {
  if (!target?.name || !dates) {
    return DEFAULT_EXPORT_FILE_NAME;
  }

  const targetName = target.name.replace(/ /g, '_');
  return `${targetName}_${dateYMD(dates.from)}_${dateYMD(dates.to)}`;
}
